import { Component } from '@angular/core';
import { IonicPage, Events, NavController } from 'ionic-angular';

import { FormBuilder } from '@angular/forms';

import { RegisterPage } from '../register/register';
import { TabsPage } from '../tabs/tabs';
import { AuthProvider } from '../../providers/auth/auth.provider';
import { AuthModel } from '../../providers/auth/auth.model';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {

  credentials: AuthModel = {
    email: '',
    password: ''
  };
  errorMessage: string = '';

  constructor(
    public navCtrl: NavController,
    public authProvider: AuthProvider,
    public events: Events,
    public formBuilder: FormBuilder
  ) {
  }

  ionViewWillLoad(){
  }

  forgotPassword(){
    console.log("this.loginForm",this.credentials);
    this.authProvider.resetPassword(this.credentials.email)
    .then(res => {
      console.log(res);
      this.navCtrl.setRoot(TabsPage);
    }, err => {
      console.log(err);
      this.errorMessage = err.message;
    })
  }
    

  tryLogin(){
    this.authProvider.doLogin(this.credentials)
    .then(res => {
      console.log(res);
      this.events.publish('user:login');
    }, err => {
      console.log(err);
      this.errorMessage = err.message;
    })
  }

  tryFacebookLogin(){
    this.authProvider.doFacebookLogin()
    .then((res) => {
      this.events.publish('user:login');
    }, (err) => {
      this.errorMessage = err.message;
    });
  }

  tryGoogleLogin(){
    this.authProvider.doGoogleLogin()
    .then((res) => {
      this.events.publish('user:login');
    }, (err) => {
      this.errorMessage = err.message;
    });
  }

  tryTwitterLogin(){
    this.authProvider.doTwitterLogin()
    .then((res) => {
      this.events.publish('user:login');
    }, (err) => {
      this.errorMessage = err.message;
    });
  }

  goRegisterPage(){
    this.navCtrl.push(RegisterPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts